import { render, staticRenderFns } from "./modal-report-issue.vue?vue&type=template&id=56d49ae5"
import script from "./modal-report-issue.vue?vue&type=script&lang=js"
export * from "./modal-report-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports